import React from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { Period } from "@state/common/PeriodConverter";
import { observer } from "mobx-react";

export default observer(function OfferHistoryPeriodItems(props: {
	store: {
		toggleUpdateProcessing: () => void;
		periodSubMenu: {
			setPeriodKey: (p: Period) => void;
			periodMenu: { period: Period; name: string }[];
			previousPeriodMenu: { period: Period; name: string }[];
		};
	};
	isExpanded: boolean;
}) {
	const params = useParams<{ period: string }>();
	const { t } = useTranslation();

	if (!props.isExpanded || !WEBPACK_IS_OFFER_HISTORY_ENABLED) {
		return null;
	}
	return (
		<ul className="nav--quaternary">
			{props.store.periodSubMenu.previousPeriodMenu.map((period) => (
				<li key={period.period} className="nav--quaternary__item">
					<div className="nav--quaternary__link">
						<span className="nav--quaternary__radio input--radio input--radio--sml">
							<input
								type="radio"
								id={period.name}
								name={period.name}
								className="nav--quaternary__box input--radio__box input--radio--sml__box"
								title={t(period.name)}
								checked={params.period === period.period}
								onChange={() => {
									props.store.toggleUpdateProcessing();
									props.store.periodSubMenu.setPeriodKey(
										period.period
									);
								}}
							/>
							<label
								htmlFor={period.name}
								className="input--radio__label input--radio--sml__label"
							>
								<span>{t(period.name)}</span>
							</label>
						</span>
					</div>
				</li>
			))}
		</ul>
	);
});
